import { createContext } from 'react'

export const GridTableScrollContext = createContext({
  allTheWayLeft: true,
  allTheWayRight: true,
})

export const GridTableVisibleColumnsContext = createContext({
  startIndex: 0,
  endIndex: Number.POSITIVE_INFINITY,
})
